export type TimelineViewportRange = {
  start: number;
  end: number;
};

// Visible horizontal span (in grid px) padded by an overscan buffer on each side.
// Columns / bands / dividers whose span intersects this range are the only ones
// that need to be in the DOM (horizontal virtualization).
export const getTimelineViewportRange = (
  scrollLeft: number,
  viewportWidth: number,
  overscan: number,
): TimelineViewportRange => ({
  start: scrollLeft - overscan,
  end: scrollLeft + viewportWidth + overscan,
});
